import React from 'react';
import { Route } from 'react-router-dom';
import Items from './giveawayNumbers';

export default <Route path="/homepage/numeros-da-sorte" component={Items} />;
